<template>
    <v-container grid-list-sm fluid text-xs-center mt-5 pt-5>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <v-layout row wrap justify-content-center pb-3 v-if="isDesktop()" style="margin-bottom:10%">
            <v-flex xs11 pb-3 pt-4 justify-content-center row>
                <v-toolbar dark flat color="rgba(255,164,9,0.8)" class="justify-content-center row">
                    <v-toolbar-title class="align-center">
                        <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%">
                        <span style="font-size: 25px" class="georgia"> Numéro Devis : {{Devis_pour_souscription.numeroDevis}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-flex>

            <v-flex xs10 sm10 md11 lg11 pb-3 justify-content-center
                    class="row block-content elevation-0 row-container grey lighten-3 border-radius">
                <!--logo Assureur et Notation étoilée-->
                <v-flex xs3 row wrap justify-content-center mt-5>
                    <v-flex>
                        <img :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)"
                             :title="Devis_pour_souscription.partenaireid.societe" alt="logo partenaire" width="150" height="120">
                        <p class="font-weight-black pl-2">{{Devis_pour_souscription.partenaireid.societe}}</p>
                    </v-flex>
                </v-flex>

                <v-flex xs3 row wrap justify-content-center mt-5>
                    <!--Tarifs-->
                    <v-flex>
                        <ul class="List-cout pl-5">
                            <li>
                                <p class="font-weight-bold text-center" style="color:#ffa409;font-size:25px;">
                                    {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                    <small>FCFA</small>
                                </p>
                            </li>
                        </ul>
                        <span class="font-weight-black title georgia">Prime TTC</span> <br>
                        <span class="title font-weight-light georgia">(Frais et taxes inclus)</span>
                    </v-flex>
                </v-flex>

                <v-flex xs4 row wrap justify-content-center>
                    <!--bouttons ...-->
                    <v-flex class="right--texting">
                        <ul class="list-boutons">
                            <li>
                                <v-btn small color="default" class="col-lg-6 col-sm-6 col-md-6 georgia">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe0cf;</i>Être
                                    Rappelé
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6">
                                    <i class="material-icons pr-4 icon-action-devis" aria-hidden="true" data-nosnippet style="margin-left:-3%">&#xe2c4;</i>
                                    Telecharger
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="payement_start"
                                       class="col-lg-6 col-sm-6 col-md-6 ">
                                    <i class="material-icons icon-action-devis mr-4" aria-hidden="true" data-nosnippet
                                       style="margin-left:-33%">&#xe8a1;</i>
                                    Payer
                                </v-btn>
                            </li>
                        </ul>
                    </v-flex>
                </v-flex>
            </v-flex>

            <!--================ Details Assurance cas Automobile WEB ======================-->
            <!-- =============== Details Assurance cas Automobile WEB ======================-->
            <!-- =============== Details Assurance cas Automobile WEB ======================-->
            <!-- =============== Details Assurance cas Automobile WEB ======================-->
            <v-flex justify-content-center row v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
                <v-flex justify-content-center xs11 sm10 md11 lg11
                        class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius">
                    <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Détails de l'assurance</p>
                    </v-flex>

                    <v-flex justify-content-center xs11 sm10 md11 lg11
                            class="row block-content elevation-0 row-container bg-transparent">
                        <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                            <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                <thead class="bg-light">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Automobile WEB===================================================-->
                                    <td v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
                                        <ul class="to-left mb-3" v-for="auto in Devis_pour_souscription.vehicules"
                                            :key="auto">
                                            <li class="font-weight-regular subheading"> Marque : <span class="to-right">{{auto.marque}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Modele : <span class="to-right">{{auto.model}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Immatriculation : <span
                                                    class="to-right">{{auto.immatriculation}}</span></li>
                                            <li class="font-weight-regular subheading"
                                                v-show="auto.categorie=='utilitaire'"> Categorie : <span>{{auto.categorie}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"
                                                v-show="auto.categorie=='utilitaire'"> Option Utilitaire : <span>{{auto.optionUtilitaire}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"
                                                v-show="auto.categorie=='utilitaire'"> Tonnage :
                                                <span>{{auto.tonnage}}</span></li>
                                            <li class="font-weight-regular subheading"
                                                v-show="auto.categorie=='2_roues'"> Volumetrie 2 roues : <span>{{auto.volumetrie2_roues}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Valeur à neuf : <span
                                                    class="to-right">{{auto.valeur}}</span></li>
                                            <li class="font-weight-regular subheading"> Valeur vénale : <span
                                                    class="to-right">{{auto.valeur_venale}}</span></li>
                                            <li class="font-weight-regular subheading"> Force : <span class="to-right">{{auto.force}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Age du véhicule : <span
                                                    class="to-right">{{auto.age}} {{auto.annee_mois}}</span></li>
                                            <li class="font-weight-regular subheading"> Nombre de places : <span
                                                    class="to-right">{{auto.nbplace}}</span></li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                    <!--============================================Liste Garanties si c'est devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche=='Automobile'">
                                        <ul class="to-left uppercase" v-for="gar in listegaranties" :key="gar"
                                            style="margin-bottom: 200px">
                                            <ul v-for="g in gar" :key="g">
                                                <li> {{g}}</li>
                                            </ul>
                                        </ul>
                                    </td>
                                    <!--============================================Autres informations===================================================-->
                                    <td>
                                        <ul class="to-left pb-3">
                                            <li class="font-weight-regular subheading"> Date d'effet :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Assureur :<span
                                                    class="to-right"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date de souscription : <span
                                                    class="to-right">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Bénéficiaire : <span
                                                    class="to-right">{{Devis_pour_souscription.proprietaire.prenom+' '+Devis_pour_souscription.proprietaire.nom}}</span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>
                </v-flex>

                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center
                        class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                    <!-- =======================================End Detail block if Habitation========================================================-->
                    <!-- How to deliver The insurance if subcripted WEB-->
                    <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Checkout</p>
                    </v-flex>

                    <v-card width="500" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="500" class="ml-5 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>


                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs11 sm10 md11 lg11 pt-2 justify-content-center v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{ mention_ttc.toLocaleString() }}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <v-flex xs11 sm10 md11 lg11>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                               @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                               style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                               @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>


            <!--================ Details Assurance cas Habitation WEB ======================-->
            <!-- =============== Details Assurance cas Habitation WEB ======================-->
            <!-- =============== Details Assurance cas Habitation WEB ======================-->
            <!-- =============== Details Assurance cas Habitation WEB ======================-->
            <v-flex justify-content-center row v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
                <v-flex justify-content-center xs11 sm10 md11 lg11
                        class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius">
                    <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Détails de l'assurance</p>
                    </v-flex>

                    <v-flex justify-content-center xs11 sm10 md11 lg11
                            class="row block-content elevation-0 row-container bg-transparent">
                        <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                            <table class="table table-sm table-bordered table-donnees text-center">
                                <thead class="bg-light">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Habitation WEB===================================================-->
                                    <td>
                                        <ul class="to-left">
                                            <li class="font-weight-regular subheading"> Type de Bien : <span
                                                    class="to-right">{{Devis_pour_souscription.typeBien}} </span></li>
                                            <li class="font-weight-regular subheading"> Type toiture : <span
                                                    class="to-right">{{Devis_pour_souscription.naturecouverture}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Superficie(en m2) : <span
                                                    class="to-right"> {{Devis_pour_souscription.nombreetage}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Adresse du logement : <span
                                                    class="to-right"> {{Devis_pour_souscription.adresselogement}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Valeur du bâtiment : <span
                                                    class="to-right">{{Devis_pour_souscription.valeurbatiment}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Valeur du contenu : <span
                                                    class="to-right">{{Devis_pour_souscription.valeurcontenu}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Qualité assuré : <span
                                                    class="to-right">{{Devis_pour_souscription.qualiteassure}} </span>
                                            </li>
                                            <li v-if="Devis_pour_souscription.qualiteassure=='locataire'"> Monatnt du
                                                loyer : <span
                                                        class="to-right">{{Devis_pour_souscription.montaLoyer}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Nombre de pièce(s) : <span
                                                    class="to-right"> {{Devis_pour_souscription.nombrepiece}} </span>
                                            </li>
                                        </ul>
                                    </td>
                                    <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche!='Automobile'">
                                        <ul class="to-left uppercase" v-for="(gar, index) in listegaranties"
                                            :key="index">
                                            <ul>
                                                <li> {{gar.libele}}</li>
                                            </ul>
                                        </ul>
                                    </td>
                                    <!--============================================Autres informations===================================================-->
                                    <td>
                                        <ul class="to-left pb-3">
                                            <li class="font-weight-regular subheading"> Date d'effet :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Assureur :<span
                                                    class="to-right"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date de souscription : <span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Proprietaire : <span
                                                    class="to-right"> {{Devis_pour_souscription.proprietaire.prenom+' '+Devis_pour_souscription.proprietaire.nom}} </span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>
                </v-flex>
                <!-- WEB --->
                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center
                        class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                    <!-- =======================================End Detail block if Habitation========================================================-->
                    <!-- How to deliver The insurance if subcripted WEB-->
                    <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Checkout</p>
                    </v-flex>

                    <v-card width="500" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="500" class="ml-5 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>


                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs11 sm10 md11 lg11 pt-2 justify-content-center v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{ mention_ttc.toLocaleString() }}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <v-flex xs11 sm10 md11 lg11>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                               @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                               style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                               @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>


            <!--================ Details Assurance cas Voyage WEB =========================-->
            <!-- =============== Details Assurance cas Voyage WEB =========================-->
            <!-- =============== Details Assurance cas Voyage WEB =========================-->
            <!-- =============== Details Assurance cas Voyage WEB =========================-->
            <v-flex justify-content-center row v-show="showPaymentBLock==true">
                <v-flex justify-content-center xs11 sm10 md11 lg11
                        class="row block-content elevation-0 row-container mt-3 bg-transparent grey lighten-3 border-radius"
                        v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                    <v-flex xs11 sm10 md11 lg11 pt-3 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Détails de l'assurance</p>
                    </v-flex>

                    <v-flex justify-content-center xs11 sm10 md11 lg11
                            class="row block-content elevation-0 row-container bg-transparent ">
                        <v-flex xs12 sm12 md12 lg12 class="table-responsive">
                            <table class="table table-sm table-bordered text-center grey lighten-5 table-donnees">
                                <thead class="bg-light">
                                <tr>
                                    <th class="head">Objet(s) assuré(s)</th>
                                    <th class="head">Garantie(s) souscrite(s)</th>
                                    <th class="head">Autres informations</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <!--============================================Details Assurance cas Voyage WEB===================================================-->
                                    <td>
                                        <ul class="to-left">
                                            <li class="font-weight-regular subheading"> Pays de depart : <span
                                                    class="to-right">{{Devis_pour_souscription.pays_domicile}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Pays de destination : <span
                                                    class="to-right">{{Devis_pour_souscription.destination.PAYS}}</span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Nombre de passagers : <span
                                                    class="to-right"> {{Devis_pour_souscription.nbpassager}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date de départ : <span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateDepart)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date de retour : <span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateArrivee)}} </span>
                                            </li>
                                        </ul>
                                    </td>
                                    <!--============================================Liste Garanties si differents de devis Auto===================================================-->
                                    <td v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche!='Automobile'">
                                        <ul class="to-left uppercase" v-for="gar in listegaranties" :key="gar">
                                            <ul>
                                                <li> {{gar}}</li>
                                            </ul>
                                        </ul>
                                    </td>
                                    <!--============================================Autres informations===================================================-->
                                    <td>
                                        <ul class="to-left pb-3">
                                            <li class="font-weight-regular subheading"> Date d'effet :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Assureur :<span
                                                    class="to-right"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                            </li>
                                            <li class="font-weight-regular subheading"> Date de souscription : <span
                                                    class="to-right"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                            </li>
                                            <v-divider></v-divider>
                                        </ul>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>

                    <v-flex xs11 sm10 md11 lg11 pb-3 pt-1 justify-content-center
                            class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius"
                            v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                        <table class="table table-sm table-bordered grey lighten-5 table-simple text-center">
                            <thead class="bg-light georgia">
                            <tr>
                                <th class="head">Genre</th>
                                <th class="head">Prénom</th>
                                <th class="head">Nom</th>
                                <th class="head">Numéro de téléphone</th>
                                <th class="head">Nationalité</th>
                                <th class="head">Date de naissance</th>
                                <th class="head">№ Passeport</th>
                                <th class="head">Date de délivrance</th>
                                <th class="head">Date d'expiration</th>
                            </tr>
                            </thead>
                            <tbody v-for="item in tableau_info_passager" :key="item.numero_ci_passager">
                            <tr>
                                <td class="font-weight-regular subheading border">{{item.genre}}</td>
                                <td class="font-weight-regular subheading border">{{item.prenom_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.nom_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.num_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.nationalite_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.dateNaissance}}</td>
                                <td class="font-weight-regular subheading border">{{item.numero_ci_passager}}</td>
                                <td class="font-weight-regular subheading border">{{item.date_delivrance}}</td>
                                <td class="font-weight-regular subheading border">{{item.date_expiration}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-flex>
                <!-- WEB --->
                <v-flex xs11 sm10 md11 lg11 pb-3 pt-4 justify-content-center
                        class="grey lighten-3 row block-content elevation-0 row-container mt-3 bg-transparent border-radius">
                    <!-- =======================================End Detail block if Habitation========================================================-->
                    <!-- How to deliver The insurance if subcripted WEB-->
                    <v-flex xs11 sm10 md11 lg11 class="justify-content-center row">
                        <p class="font-weight-black headline georgia">Checkout</p>
                    </v-flex>

                    <v-card width="500" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Réseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="500" class="ml-5 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>

                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs11 sm10 md11 lg11 pt-2 justify-content-center v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{ mention_ttc.toLocaleString() }}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <v-flex xs11 sm10 md11 lg11>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'" @click="payement_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                               @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                               style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'" @click="payement_om_start"
                               class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                        <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                               @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                            Payer
                        </v-btn>
                    </v-flex>
                </v-flex>
            </v-flex>

            <!-- pop pour remplissage informations passagers Desktop-->
            <v-dialog v-model="dialogInfoPassager" persistent
                      v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                <v-card v-if="isDesktop()" elevation="24" class="border-radius">
                    <v-toolbar card color="#ffa409">
                        <span class="font-weight-black title georgia" style="color:#fff">
                            <v-icon color="#fff">&#xe92d;</v-icon>
                            Informations passager(s) 
                        </span>
                    </v-toolbar>

                    <v-flex class="border-radius grey lighten-3 column text-center mt-3 ml-3 mr-3">
                        <v-flex>
                            <v-form class="text-center row">
                                <v-container class="text-center">
                                    <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                        <v-flex md3>
                                            <v-radio-group class="justify-content-center row" v-model="genre" row>
                                                <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                        <v-flex md3 class="ml-2">
                                            <v-text-field v-model="prenom_passager" prepend-inner-icon="person"
                                                          label="Prénom*" required
                                                          hint="Votre prénom complet"></v-text-field>
                                        </v-flex>
                                        <v-flex md3>
                                            <v-text-field class="ml-2" v-model="nom_passager"
                                                          prepend-inner-icon="person" label="Nom*" required
                                                          hint="Votre nom complet"></v-text-field>

                                        </v-flex>
                                    </v-layout>

                                    <v-layout ml-3 mr-3 pt-3 class="row justify-content-center">
                                        <v-flex md3 style="margin-top:-20px">
                                            <v-text-field @keypress="onlyNumber" prepend-inner-icon="phone"
                                                          v-model="num_passager" label="Téléphone*" required
                                                          hint="Votre numéro de téléphone"></v-text-field>
                                        </v-flex>

                                        <v-flex class="ml-2" md3 style="margin-top:-25px">
                                            <label for=""> Nationalité* </label>
                                            <select solo v-model="nationalite_passager"
                                                    class="border selectatDesktop col-md-11  pt-3">
                                                <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                                    {{itm.PAYS}}
                                                </option>
                                            </select>
                                        </v-flex>

                                        <v-flex md3 style="margin-top:-20px">
                                            <v-menu lazy :close-on-content-click="false" v-model="datePickerDateNais"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de naissance*"
                                                              v-model="dateNaissance"
                                                              prepend-inner-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="dateNaissance" class="mt-3"
                                                               :max="new Date().toISOString().substr(0, 10)"
                                                               @input="datePickerDateNais=false"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout ml-3 mr-3 pt-3 class="justify-content-center">
                                        <v-flex md3 class="row" style="margin-top:-20px">
                                            <v-text-field v-model="numero_ci_passager" prepend-inner-icon="person"
                                                          placeholder="№ Passeport*" required type="text"
                                                          hint="Numéro Passeport"></v-text-field>
                                        </v-flex>

                                        <v-flex class="ml-2" md3 style="margin-top:-20px">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuDelivrance"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de délivrance*"
                                                              v-model="date_delivrance"
                                                              prepend-inner-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_delivrance" class="mt-3"
                                                               @input="menuDelivrance=false" min="1950-01-01"
                                                               :max="new Date().toISOString().substr(0, 10)"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex md3 style="margin-top:-20px">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuExpiration"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date expiration*"
                                                              v-model="date_expiration"
                                                              prepend-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_expiration" class="mt-3"
                                                               @input="menuExpiration=false"
                                                               :min="new Date().toISOString().substr(0, 10)"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-flex>
                    </v-flex>

                    <v-flex class="row">
                        <div class="col-sm-12 text-center">
                            <v-btn class="font-weight-bold text-white" round color="red" to="/">Annuler</v-btn>
                            <v-btn class="font-weight-bold text-white" round color="#ffa409"
                                   @click="Detail_info_passager">Ajouter
                            </v-btn>
                        </div>
                    </v-flex>

                    <v-layout wrap>
                        <v-flex xs12 ml-5 mr-5>
                            <table class="table table-simple text-center">
                                <thead class="bg-light">
                                <tr>
                                    <th>Genre</th>
                                    <th>Prénom</th>
                                    <th>Nom</th>
                                    <th>Numéro de téléphone</th>
                                    <th>Nationalité</th>
                                    <th>Date de naissance</th>
                                    <th>№ Passeport</th>
                                    <th>Date de délivrance</th>
                                    <th>Date d'expiration</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tableau_info_passager" :key="item.numero_ci_passager">
                                <tr>
                                    <td class="border">{{item.genre}}</td>
                                    <td class="border">{{item.prenom_passager}}</td>
                                    <td class="border">{{item.nom_passager}}</td>
                                    <td class="border">{{item.num_passager}}</td>
                                    <td class="border">{{item.nationalite_passager}}</td>
                                    <td class="border">{{item.dateNaissance}}</td>
                                    <td class="border">{{item.numero_ci_passager}}</td>
                                    <td class="border">{{item.date_delivrance}}</td>
                                    <td class="border">{{item.date_expiration}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </v-flex>

                        <v-flex class="justify-content-center row" v-show="continue_btn">
                            <v-btn class="font-weight-bold text-white " round color="#ffa409" @click="ManipPaiement()">
                                Continuer
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>

        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      ================ -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <v-container v-if="isMobile()"
                     style="padding-right:25px!important;padding-bottom:25px!important; padding-left:25px!important;margin-bottom:30%">
            <!-- MOBILE --->
            <v-flex pt-2>
                <v-toolbar dark flat color="rgba(255,164,9,0.8)">
                    <v-toolbar-title class="align-center">
                        <img src="../assets/img/pictos/credit-card.png" alt="Devis Auto" width="10%">
                        <span style="font-size: 15px" class="georgia"> Nº Devis : {{Devis_pour_souscription.numeroDevis}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-flex>

            <v-layout column justify-content-center
                      class="ml-2 mt-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                <!--logo Assureur et Notation étoilée-->
                <v-flex justify-content-center style="text-align: center; margin-top:-2%" class="pt-5 ">
                    <img :src="getImgUrl(Devis_pour_souscription.partenaireid.logo)"
                         :title="Devis_pour_souscription.partenaireid.societe" alt="logo partenaire" width="130" height="100">
                    <p class="font-weight-black georgia">{{Devis_pour_souscription.partenaireid.societe}}</p>
                </v-flex>

                <!--bouttons ...-->
                <v-flex row wrap xs12 sm10 md11 lg11 pb-3 pt-2>
                    <v-flex row wrap justify-content-center class="right--texting pl-3">
                        <ul class="list-boutons">
                            <li>
                                <v-btn small color="default" class="col-lg-6 col-sm-6 col-md-6 font-weight-bold">
                                    <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0cf;</i>Être Rappelé
                                </v-btn>
                            </li>

                            <li>
                                <v-btn small color="default" @click="devisParMail(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 font-weight-bold">
                                    <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe0be;</i> Devis par mail
                                </v-btn>
                            </li>
                            <li>
                                <v-btn small color="default" @click="telecharger_le_devis(Devis_pour_souscription)"
                                       class="col-lg-6 col-sm-6 col-md-6 font-weight-bold">
                                    <i class="material-icons pr-4" aria-hidden="true" data-nosnippet>&#xe2c4;</i> Télécharger
                                </v-btn>
                            </li>
                            <li>
                                <v-btn small color="default" @click="payement_start"
                                       class="col-lg-6 col-sm-6 col-md-6 font-weight-bold">
                                    <i class="material-icons" aria-hidden="true" data-nosnippet style="margin-left:-32%;padding-right:25px">&#xe8a1;</i>
                                    Payer
                                </v-btn>
                            </li>
                        </ul>
                    </v-flex>

                    <v-flex xs12 class="pt-4">
                        <ul class="List-cout">
                            <li>
                                <p class="font-weight-black title justify-content-center row" style="color:#ffa409">
                                    {{Devis_pour_souscription.prime_ttc.toLocaleString()}}
                                    <small>FCFA</small>
                                </p>
                            </li>
                            <span class="font-weight-black title justify-content-center row georgia">Prime totale</span>
                            <li><p class="justify-content-center row georgia">(Frais de dossier inclus)</p></li>
                        </ul>
                    </v-flex>
                </v-flex>
            </v-layout>

            <!-- =========== Details Assurance cas Automobile MOBILE ===================-->
            <!-- =========== Details Assurance cas Automobile MOBILE ===================-->
            <!-- =========== Details Assurance cas Automobile MOBILE ===================-->
            <!-- =========== Details Assurance cas Automobile MOBILE ===================-->
            <v-layout column justify-content-center v-if="Devis_pour_souscription.brancheid.branche=='Automobile'">
                <v-layout column justify-content-center
                          class="ml-2 mt-3 pb-3 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Détails de l'assurance</span>
                    </v-flex>

                    <v-flex class="row mt-2 georgia" justify-content-center>
                        <!--============================================Details Assurance cas Automobile MOBILE===================================================-->
                        <v-flex justify-content-center ml-3 row>
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                    <v-toolbar-title>Objet(s) assuré(s)</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color:grey">
                                    <ul class="to-left georgia" style="margin-left:-7%"
                                        v-for="auto in Devis_pour_souscription.vehicules" :key="auto">
                                        <li class="font-weight-regular subheading">Marque : <span
                                                class="to-right-mobile">{{auto.marque}}</span></li>
                                        <li class="font-weight-regular subheading"> Modele : <span
                                                class="to-right-mobile">{{auto.model}}</span></li>
                                        <li class="font-weight-regular subheading"> Immatriculation : <span
                                                class="to-right-mobile"> {{auto.immatriculation}} </span></li>
                                        <li class="font-weight-regular subheading"
                                            v-show="auto.categorie=='utilitaire'"> Categorie :
                                            <span> {{auto.categorie}} </span></li>
                                        <li class="font-weight-regular subheading"
                                            v-show="auto.categorie=='utilitaire'"> Option Utilitaire : <span
                                                class="to-right-mobile"> {{auto.optionUtilitaire}} </span></li>
                                        <li class="font-weight-regular subheading"
                                            v-show="auto.categorie=='utilitaire'"> Tonnage : <span
                                                class="to-right-mobile"> {{auto.tonnage}} </span></li>
                                        <li class="font-weight-regular subheading" v-show="auto.categorie=='2_roues'">
                                            Volumetrie 2 roues : <span class="to-right-mobile"> {{auto.volumetrie2_roues}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Valeur à neuf : <span
                                                class="to-right-mobile"> {{auto.valeur}} </span></li>
                                        <li class="font-weight-regular subheading"> Valeur vénale : <span
                                                class="to-right-mobile"> {{auto.valeur_venale}} </span></li>
                                        <li class="font-weight-regular subheading"> Age du véhicule : <span
                                                class="to-right-mobile"> {{auto.age}} {{auto.annee_mois}}</span></li>
                                        <li class="font-weight-regular subheading"> Nombre de places : <span
                                                class="to-right-mobile"> {{auto.nbplace}} </span></li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!--==== Listes garanties MOBILE ===-->
                        <v-flex justify-content-center ml-3 row
                                v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche=='Automobile'"
                                class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                    <v-toolbar-title>Garantie(s) souscrite(s)</v-toolbar-title>
                                </v-toolbar>
                                <v-item-group style="color: grey;">
                                    <ul class="to-left uppercase" v-for="gar in listegaranties" :key="gar">
                                        <ul v-for="g in gar" :key="g">
                                            <li> {{g}}</li>
                                        </ul>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!--==== others informations for the current DEVIS MOBILE===-->
                        <v-flex justify-content-center ml-3 row class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark>
                                    <v-toolbar-title class="georgia">Autres informations</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color: grey;">
                                    <ul class="to-left georgia" style="margin-left:-7%">
                                        <li class="font-weight-regular subheading"> Date d'effet :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Assureur :<span
                                                class="to-right-mobile"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date de souscription : <span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Bénéficiaire : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.proprietaire.prenom+' '+Devis_pour_souscription.proprietaire.nom}}</span>
                                        </li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <!-- How to deliver The insurance if subcripted MOBILE-->
                <v-flex justify-content-center row class="ml-2 mr-2 grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Checkout</span>
                    </v-flex>

                    <v-card width="330" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>
                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Reseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="330" class="mt-2 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>
                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>

                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs8 class="bg-transparent" v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{mention_ttc.toLocaleString()}}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <div class="row block-content elevation-0 row-container bg-transparent">
                        <v-flex xs8 class="offset-2 pr-5">
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>
                            <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                                   @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'"
                                   @click="payement_om_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>

                        </v-flex>
                    </div>
                </v-flex>
            </v-layout>

            <!-- =========== Details Assurance cas Habitation MOBILE ===================-->
            <!-- =========== Details Assurance cas Habitation MOBILE ===================-->
            <!-- =========== Details Assurance cas Habitation MOBILE ===================-->
            <!-- =========== Details Assurance cas Habitation MOBILE ===================-->
            <v-layout column justify-ontent-center v-if="Devis_pour_souscription.brancheid.branche=='Habitation'">
                <v-layout column justify-content-center
                          class="ml-2 mt-3 pb-3 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Détails de l'assurance</span>
                    </v-flex>

                    <v-flex class="row mt-2 georgia" justify-content-center>
                        <!--============================================Details Assurance cas Habitation MOBILE===================================================-->
                        <v-flex justify-content-center ml-3 row>
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark>
                                    <v-toolbar-title>Objet(s) assuré(s)</v-toolbar-title>
                                </v-toolbar>
                                <v-item-group>
                                    <ul class="to-left georgia" style="margin-left:-7%">
                                        <li class="font-weight-regular subheading"> Type de Bien : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.typeBien}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Type toiture : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.naturecouverture}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Superficie (en m2) : <span
                                                class="to-right-mobile"> {{Devis_pour_souscription.nombreetage}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Adresse du logement : <span
                                                class="to-right-mobile"> {{Devis_pour_souscription.adresselogement}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Valeur du bâtiment : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.valeurbatiment}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Valeur du contenu : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.valeurcontenu}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Qualité assuré : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.qualiteassure}} </span>
                                        </li>
                                        <li v-if="Devis_pour_souscription.qualiteassure=='locataire'">> Monatnt du loyer
                                            : <span>{{Devis_pour_souscription.montaLoyer}} </span></li>
                                        <li class="font-weight-regular subheading"> Nombre de pièce(s) : <span
                                                class="to-right-mobile"> {{Devis_pour_souscription.nombrepiece}} </span>
                                        </li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!-- garanties list for the current DEVIS MOBILE-->
                        <v-flex justify-content-center ml-3 row
                                v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche!='Automobile'"
                                class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                    <v-toolbar-title>Garantie(s) souscrite(s)</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color: grey;">
                                    <ul class="to-left uppercase" v-for="gar in listegaranties" :key="gar">
                                        <li>{{gar.libele}}</li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!--==== others informations for the current DEVIS MOBILE===-->
                        <v-flex justify-content-center ml-3 row class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark>
                                    <v-toolbar-title class="georgia">Autres informations</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color: grey;">
                                    <ul class="to-left georgia" style="margin-left:-7%">
                                        <li class="font-weight-regular subheading"> Date d'effet :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Assureur :<span
                                                class="to-right-mobile"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date de souscription : <span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Proprietaire : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.proprietaire.prenom+' '+Devis_pour_souscription.proprietaire.nom}}</span>
                                        </li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <!-- How to deliver The insurance if subcripted MOBILE-->
                <v-flex justify-content-center row class=" ml-2 mr-2 grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Checkout</span>
                    </v-flex>

                    <v-card width="330" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Reseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="330" class="mt-2 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>
                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>

                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs8 class="bg-transparent" v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{mention_ttc.toLocaleString()}}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <div class="row block-content elevation-0 row-container bg-transparent">
                        <v-flex xs8 class="offset-2 pr-5">
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>
                            <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                                   @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'"
                                   @click="payement_om_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>
                        </v-flex>
                    </div>
                </v-flex>
            </v-layout>

            <!--============ Details Assurance cas Voyage MOBILE ========================-->
            <!--============ Details Assurance cas Voyage MOBILE ========================-->
            <!--============ Details Assurance cas Voyage MOBILE ========================-->
            <!--============ Details Assurance cas Voyage MOBILE ========================-->
            <v-layout v-show="showPaymentBLock==true" column justify-content-center
                      v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                <v-layout column justify-content-center
                          class="ml-2 mt-3 pb-2 mb-3 mr-2 row wrap-content elevation-0 row-container grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Détails de l'assurance</span>
                    </v-flex>

                    <v-flex class="row mt-2 georgia" justify-content-center>
                        <!--============================================Details Assurance cas Voyage MOBILE===================================================-->
                        <v-flex justify-content-center row ml-3>
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark>
                                    <v-toolbar-title>Objet(s) assuré(s)</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group>
                                    <ul class="to-left georgia" style="margin-left:-7%">
                                        <li class="font-weight-regular subheading"> Pays de depart : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.pays_domicile}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Pays de destination : <span
                                                class="to-right-mobile">{{Devis_pour_souscription.destination.PAYS}}</span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Nombre de passagers : <span
                                                class="to-right-mobile"> {{Devis_pour_souscription.nbpassager}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date de départ :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateDepart)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date de retour :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateArrivee)}} </span>
                                        </li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!-- garanties list for the current DEVIS MOBILE-->
                        <v-flex justify-content-center ml-3 row
                                v-show="this.$store.state.devispayementDiffere.devis.brancheid.branche!='Automobile'"
                                class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark width="50">
                                    <v-toolbar-title>Garantie(s) souscrite(s)</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color: grey;">
                                    <ul class="to-left uppercase" v-for="gar in listegaranties" :key="gar">
                                        <li>{{gar}}</li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <!--==== others informations for the current DEVIS MOBILE===-->
                        <v-flex justify-content-center ml-3 row class="pt-2">
                            <v-card width="330">
                                <v-toolbar card color="rgb(91, 148, 188)" dark>
                                    <v-toolbar-title class="georgia">Autres informations</v-toolbar-title>
                                </v-toolbar>

                                <v-item-group style="color: grey;">
                                    <ul class="to-left georgia" style="margin-left:-7%">
                                        <li class="font-weight-regular subheading"> Date d'effet :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEffet)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date d'échéance :<span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateEcheance)}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Assureur :<span
                                                class="to-right-mobile"> {{Devis_pour_souscription.partenaireid.societe}} </span>
                                        </li>
                                        <li class="font-weight-regular subheading"> Date de souscription : <span
                                                class="to-right-mobile"> {{DateFormater(Devis_pour_souscription.dateSouscription)}} </span>
                                        </li>
                                    </ul>
                                </v-item-group>
                            </v-card>
                        </v-flex>

                        <v-flex justify-content-center ml-3 row class="pt-2">
                            <table class="table table-simple text-center">
                                <thead class="bg-light georgia">
                                <tr>
                                    <th class="head">Prénom</th>
                                    <th class="head">Nom</th>
                                </tr>
                                </thead>
                                <tbody v-for="item in tableau_info_passager" :key="item.prenom_passager">
                                <tr style="background:#fff">
                                    <td class="font-weight-regular subheading border">{{item.prenom_passager}}</td>
                                    <td class="font-weight-regular subheading border">{{item.nom_passager}}</td>

                                </tr>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-flex>
                </v-layout>

                <!-- How to deliver The insurance if subcripted MOBILE-->
                <v-flex justify-content-center row class="ml-2 mr-2 grey lighten-3 border border-radius">
                    <v-flex>
                        <span class="font-weight-black headline georgia">Checkout</span>
                    </v-flex>

                    <v-card width="330" class="border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de livraison</v-toolbar-title>
                        </v-toolbar>

                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_livraison" class="answer">
                                    <v-radio color="#ffa409" class="highlight"
                                             label="A domicile (à partir de 1500 FCFA TTC)" @change="adresse = true"
                                             value="a_docimicile"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Reseau partenaire (500 FCFA TTC)"
                                             value="reseau_partenaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Assur'Store (gratuit)"
                                             value="locaux_assuraf"></v-radio>
                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-card width="330" class="mt-2 border-radius">
                        <v-toolbar card color="#ffa409" dark>
                            <v-toolbar-title>Mode de paiement</v-toolbar-title>
                        </v-toolbar>
                        <v-item-group style="margin-top:-12px">
                            <ul>
                                <v-radio-group full-width v-model="mode_payement" class="answer">
                                    <v-radio color="#ffa409" class="highlight" label="Orange Money"
                                             value="mobile_money"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Carte Bancaire"
                                             value="carte_bancaire"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Autres paiements mobiles"
                                             value="autre_paiement"></v-radio>
                                    <v-radio color="#ffa409" class="highlight" label="Paiement réseau partenaire"
                                             value="reseau_partenaire"></v-radio>

                                </v-radio-group>
                            </ul>
                        </v-item-group>
                    </v-card>

                    <v-flex xs8 class="bg-transparent" v-show="mode_livraison">
                        <span class="font-weight-black h2"> TTC : <span class="red--text">{{mention_ttc.toLocaleString()}}</span> <small> FCFA</small> </span>
                    </v-flex>

                    <div class="row block-content elevation-0 row-container bg-transparent">
                        <v-flex xs8 class="offset-2 pr-5">
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'autre_paiement'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>
                            <!-- boutton pour carte Bancaire qui appelle la fonction de inTouch -->
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'carte_bancaire'"
                                   @click="payement_intouch_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'mobile_money'"
                                   @click="payement_om_start" class="col-sm-3 georgia border-radius"
                                   style="height:40px">
                                Payer
                            </v-btn>
                            <v-btn dark color="#ffa409" v-show="mode_payement == 'reseau_partenaire'"
                                   @click="payement_start" class="col-sm-3 georgia border-radius" style="height:40px">
                                Payer
                            </v-btn>

                        </v-flex>
                    </div>
                </v-flex>
            </v-layout>

            <!-- How to paye The insurance if subcripted -->
            <!-- =======================================End Detail block if Habitation========================================================-->
            <!-- Modal for payment information -->
            <v-dialog v-model="dialog" persistent max-width="600px">
                <!-- Payement by mobile money -->
                <v-card v-if="mode_payement=='mobile_money'">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">Payement Mobile Money</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false" class="float-lg-right" style="background: #ffa409">
                            <v-icon>&#xe5cd;</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field label="Votre mot de passe *" type="password" required></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <small style="color:#ffa409">*indicates required field</small>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="payement_end(Devis_pour_souscription)">Payer</v-btn>
                        <v-btn color="blue darken-1" flat @click="dialog = false">Save</v-btn>
                    </v-card-actions>
                </v-card>

                <!-- Payement by bank card -->
                <v-card v-if="mode_payement=='carte_bancaire'">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">Payement par carte Bancaire</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false" class="float-lg-right" style="background: #ffa409">
                            <v-icon>&#xe5cd;</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field label="Type information*" hint="Type d'information à remplir" required
                                                  solo></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field label="Votre mot de passe *" type="password" required></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <small style="color:#ffa409">*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="payement_end(Devis_pour_souscription)">Payer</v-btn>
                        <v-btn color="blue darken-1" flat @click="dialog = false">Annuler</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogInfoPassagerMobile" persistent
                      v-if="Devis_pour_souscription.brancheid.branche=='Voyage'">
                <v-card v-if="isMobile()" class="border-radius georgia scroll">
                    <v-toolbar card color="#ffa409">
                        <span class="font-weight-black title" style="color:#fff">
                            <v-icon color="#fff">&#xe92d;</v-icon>
                            <span style="font-weight:bold;font-size:14px!important;">Informations passager(s)</span>
                        </span>
                    </v-toolbar>
                    <v-flex class="border-radius grey lighten-3 row ml-3 mr-3 mt-3 mb-3">
                        <v-flex xs12 ml-3 mr-3>
                            <v-form>
                                <v-container class="georgia">
                                    <v-layout column pl-2 pr-2>
                                        <v-flex xs12 md4 mb-4>
                                            <v-radio-group class="justify-content-center row" v-model="genre" row>
                                                <v-radio color="#ffa409" label="Madame" value="Femme"></v-radio>
                                                <v-radio color="#ffa409" label="Monsieur" value="Homme"></v-radio>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-text-field v-model="prenom_passager" prepend-inner-icon="person"
                                                          label="Prénom*" required
                                                          hint="Votre prénom complet"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-text-field v-model="nom_passager" prepend-inner-icon="person"
                                                          label="Nom*" required hint="Votre nom complet"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-text-field @keypress="onlyNumber" v-model="num_passager"
                                                          prepend-inner-icon="phone" label="Numéro de téléphone*"
                                                          required hint="Votre numéro de téléphone"></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout column pl-2 pr-2>
                                        <v-flex xs12 md4 class="to-top mb-4">
                                            <label for=""> Nationalite* </label>
                                            <select v-model="nationalite_passager"
                                                    class="border col-md-11 selectatMobile pt-2">
                                                <option v-for="itm in countries" :key="itm.PAYS" :value="itm.PAYS">
                                                    {{itm.PAYS}}
                                                </option>
                                            </select>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-menu lazy :close-on-content-click="false" v-model="datePickerDateNais"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de naissance*"
                                                              v-model="dateNaissance"
                                                              prepend-inner-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="dateNaissance" class="mt-3"
                                                               :max="new Date().toISOString().substr(0, 10)"
                                                               @input="datePickerDateNais=false"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-text-field v-model="numero_ci_passager" prepend-inner-icon="person"
                                                          label="№ Passeport*" required
                                                          hint="Numéro Passport"></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout column pl-2 pr-2>
                                        <v-flex xs12 md4 class="to-top">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuDelivrance"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date de délivrance*"
                                                              v-model="date_delivrance"
                                                              prepend-inner-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_delivrance" class="mt-3"
                                                               @input="menuDelivrance=false" min="1950-01-01"
                                                               :max="new Date().toISOString().substr(0, 10)"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>

                                        <v-flex xs12 md4 class="to-top">
                                            <v-menu lazy :close-on-content-click="false" v-model="menuExpiration"
                                                    transition="scale-transition" offset-y full-width :nudge-right="20"
                                                    max-width="290px" min-width="290px">
                                                <v-text-field slot="activator" label="Date expiration*"
                                                              v-model="date_expiration"
                                                              prepend-inner-icon="event"></v-text-field>
                                                <v-date-picker color="#ffa409" v-model="date_expiration" class="mt-3"
                                                               @input="menuExpiration=false"
                                                               :min="new Date().toISOString().substr(0, 10)"
                                                               locale="fr-fr"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-flex>
                    </v-flex>

                    <v-flex class="justify-content-center row ml-2 mr-2">
                        <v-btn class="font-weight-bold text-white justify-content-center row" round color="red" to="/">
                            Annuler
                        </v-btn>
                        <v-btn class="font-weight-bold text-white justify-content-center row" round color="#ffa409"
                               @click="Detail_info_passager"> Ajouter
                        </v-btn>
                    </v-flex>

                    <v-flex class="row text-center ml-3 mr-3">
                        <table class="table table-simple text-center">
                            <thead class="bg-light georgia">
                            <tr>
                                <th>Prénom</th>
                                <th>Nom</th>
                            </tr>
                            </thead>
                            <tbody v-for="item in tableau_info_passager" :key="item.prenom_passager">
                            <tr style="background:#fff">
                                <td class="border">{{item.prenom_passager}}</td>
                                <td class="border">{{item.nom_passager}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </v-flex>

                    <v-flex class="justify-content-center ml-1 row" v-show="continue_btn">
                        <v-btn class="font-weight-bold text-white" round color="#ffa409" @click="ManipPaiement()">
                            Continuer
                        </v-btn>
                    </v-flex>
                </v-card>
            </v-dialog>
        </v-container>

        <!-- pop pour remplissage informations passagers Mobile-->
        <v-dialog v-model="dialogAlert" persistent>
            <v-card>
                <v-toolbar>
                    <v-toolbar-title>
                        <span class="headline">ALERT PAIMENT NON FINALISE</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogAlert = false" class="float-lg-right" style="background: #ffa409">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6 md4>
                                <v-text-field v-model="nom_passager" label="Nom *" hint="Nom" required></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn round outline color="success" flat>Ajouter</v-btn>
                            <v-btn round outline color="blue darken-1" flat @click="dialogAlert = false">Annuler</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="adresse" persistent max-width="500" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-toolbar color="#ffa409">
                    <v-toolbar-title class="georgia text-white"> Choix livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="grey lighten-3">
                    <v-layout class="justify-content-center">
                        <p class="mr-5 mt-2 font-weight-bold georgia">Tarif Normal</p>
                        <p class="ml-3 mt-2 font-weight-bold georgia">Tarif Express</p>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="justify-content-center container">
                            <form class="form cf">
                                <v-flex class="justify-content-center row" style="margin-top:30px">
                                    <section class="ml-2 justify-conten-center row plan cf">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="free-label" for="dakar_normal"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">1500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                                </span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_express"
                                                       value="dakar_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="basic-label col" for="dakar_express"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison dans les 2 heures</strong>
                                                </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>

                                <v-flex class="justify-content-center row" style="margin-top:-25px">
                                    <section class="ml-2 justify-conten-center row row plan cf">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_normal"
                                                       value="banlieue_normal" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                                </span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_express"
                                                       value="banlieue_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="optimium-label col" for="banlieue_express"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="span font-weight-bold">2500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison dans les 3 heures</strong>
                                                </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>
                            </form>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-5 mr-5">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                            label="Veuillez selectionner votre quartier" editable item-text="quartier"
                                            item-value="quartier" color="#59595b"></v-overflow-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex>
                            <v-text-field class="ml-5 mr-5" prepend-inner-icon="map"
                                          label="Renseigner adresse de livraison "
                                          v-model="adresselivraison"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-btn round class="font-weight-bold text-white" style="background:red" flat
                               @click="cancelPaiement()"> Annuler
                        </v-btn>
                        <v-btn round class="font-weight-bold text-white" style="background:#ffa409" flat
                               @click="getAdressLivraison"> Valider
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="adresse" persistent max-width="500" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
                <v-toolbar color="#ffa409">
                    <v-toolbar-title class="georgia text-white"> Livraison <span style="font-size: 14px">(Dakar et Banlieue)</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cancelPaiement()" class="float-lg-right">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container class="grey lighten-3">
                    <v-layout class="justify-content-center">
                        <p class="mr-5 mt-2 font-weight-bold georgia">Tarif Normal</p>
                        <p class="ml-3 mt-2 font-weight-bold georgia">Tarif Express</p>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <div class="justify-content-center container">
                            <form class="form cf">
                                <v-flex class="justify-content-center row" style="margin-top:30px">
                                    <section class="ml-2 justify-conten-center row plan cf">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_normal" value="dakar_normal"
                                                       v-model="prix_livraison" @change="showListCity">
                                                <label v-on="on" class="free-label" for="dakar_normal"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">1500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison le jour <br> même si contrat jusque <br> midi sinon lendemain</strong>
                                                </span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="dakar_express"
                                                       value="dakar_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="basic-label col" for="dakar_express"
                                                       style="padding-top:15px;white-space: pre-wrap;">
                                                    Dakar
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison dans les 2 heures</strong>
                                                </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>

                                <v-flex class="justify-content-center row" style="margin-top:-25px">
                                    <section class="ml-2 justify-conten-center row row plan cf">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_normal"
                                                       value="banlieue_normal" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="premium-label col" for="banlieue_normal"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2000 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison au plus tard le lendemain</strong>
                                                </span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <input type="radio" name="radio1" id="banlieue_express"
                                                       value="banlieue_express" v-model="prix_livraison"
                                                       @change="showListCity">
                                                <label v-on="on" class="optimium-label col" for="banlieue_express"
                                                       style="padding-top:10px;white-space: pre-wrap;">
                                                    Banlieue
                                                    <span class="font-weight-bold">2500 FCFA</span>
                                                </label>
                                            </template>
                                            <span>
                                                    <strong class="font-weight-bold">Livraison dans les 3 heures</strong>
                                                </span>
                                        </v-tooltip>
                                    </section>
                                </v-flex>
                            </form>
                        </div>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-4 mr-4">
                            <v-overflow-btn v-if="ville" :items="ville" class="select" v-model="quartier"
                                            label="Veuillez selectionner votre quartier" item-text="quartier"
                                            item-value="quartier" color="#59595b"></v-overflow-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-flex class="ml-4 mr-4">
                            <v-text-field label="Renseigner adresse de livraison "
                                          v-model="adresselivraison"></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout class="justify-content-center">
                        <v-btn round class="font-weight-bold text-white" style="background:red" flat
                               @click="cancelPaiement()"> Annuler
                        </v-btn>
                        <v-btn round class="font-weight-bold text-white" style="background:#ffa409" flat
                               @click="getAdressLivraison"> Valider
                        </v-btn>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import Api from '../services/Api'
    import getUpay from './../services/getUpay'
    import ville from './../common/ville'

    export default {
        data() {
            return {
                adresse: false,
                adresselivraison: null,
                genre: null,
                headers: [
                    {text: 'Marque & Modèle', value: 'marque'},
                    {text: 'Immatriculation', value: 'immatriculation'},
                    {text: 'Catégorie', value: 'catégorie'},
                    {text: 'Force', value: 'force'},
                    {text: 'Age', value: 'age'},
                    {text: 'Valeur neuf', value: 'valeur'},
                    {text: 'Valeur actuelle', value: 'valeur_actuelle'},
                    {text: 'Nbr places', value: 'nbplace'},
                    {text: 'Actions'}
                ],
                autoHeight: true,
                x: null,
                dialogAlert: false,
                Devis_pour_souscription: [],
                prix_livraison: null,
                mode_livraison: null,
                listVille: ville,
                ville: null,
                quartier: '',
                mention_ttc: null,
                showPaymentBlock: false,
                menuDelivrance: false,
                menuExpiration: false,
                mode_payement: null,
                notifDeviParMail: null,
                listegaranties: [],
                countries: null,
                tableau_info_passager: [],
                nbPassager: null,
                frais_livraison: null,
                branche: null,
                dateNaissance: null,
                continue_btn: false,
                dialogInfoPassager: true,
                dialogInfoPassagerMobile: true,
                dialog: false,
                IsPaid: false,
                contratToStore: null,
                nom_passager: null,
                prenom_passager: null,
                nationalite_passager: null,
                numero_ci_passager: null,
                date_delivrance: null,
                date_expiration: null,
                notif: null,
                Mano: null,
                ToastTabSucess: {
                    // Customized options for success toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                },
                ToastTabError: {
                    // Customized options for error toast
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 2000,
                    fitToScreen: true,
                    type: 'error',
                },
            }
        },

        methods: {
            cancelPaiement() {
                this.adresse = false;
                this.mode_livraison = null;
                this.adresselivraison = ''
            },

            /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
            onlyNumber($event) {
                let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
                if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                    $event.preventDefault();
                }
            },
            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            },

            showListCity() {
                if (this.prix_livraison == 'dakar_normal' || this.prix_livraison == 'dakar_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Dakar;
                    this.quartier = null
                } else if (this.prix_livraison == 'banlieue_normal' || this.prix_livraison == 'banlieue_express') {
                    this.dakar = true;
                    this.ville = this.listVille.Banlieue;
                    this.quartier = null
                }
            },

            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../assets/img/assuraf_sm.png')
                }
            },

            devisParMail: function (params) {
                Api().get('devis/mydevisbyemail/' + params._id)
                    .then(response => {
                        this.notifDeviParMail = response.data.info
                    })
            },

            // Get la liste des pays
            getListePays: function () {
                Api().get('pays')
                    .then(response => {
                        this.countries = response.data
                    })
                    .catch(err => {
                        err
                    })
            },

            getAdressLivraison: function () {
                if (this.prix_livraison) {
                    if (this.prix_livraison == 'dakar_normal') {
                        this.mention_ttc = parseInt(this.svgTTC) + 1500

                    } else if (this.prix_livraison == 'dakar_express') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_normal') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2000
                    } else if (this.prix_livraison == 'banlieue_express') {
                        this.mention_ttc = parseInt(this.svgTTC) + 2500
                    }

                    if (this.adresselivraison && this.quartier) {
                        localStorage.setItem('adressliv', this.adresselivraison);
                        this.adresse = false;
                        (localStorage.getItem('adressliv'))
                    } else {
                        this.$toasted.show("Adresse de livraison obligatoire ! ", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show("veuillez choisir un mode de livraison ! ", this.ToastTabError)

                }


            },

            // chargement du popup pour les infos de payement
            payement_start: function () {
                if (this.mode_payement) {
                    if (this.mode_livraison) {
                        this.getPay()
                    } else {
                        this.$toasted.show('Mode livraison obligatoire !', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Mode de payement obligatoire !', this.ToastTabError)
                }

            },
            // chargement du popup pour les infos de payement avec inTouch
            payement_intouch_start: function () {
                if (this.mode_payement) {
                    if (this.mode_livraison) {
                        this.getPayintouch()
                    } else {
                        this.$toasted.show('Mode livraison obligatoire !', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Mode de payement obligatoire !', this.ToastTabError)
                }

            },
            payement_om_start: function () {
                if (this.mode_payement) {
                    if (this.mode_livraison) {
                        getOm(this.mention_ttc, this.mode_payement)
                        /*  let url = localStorage.getItem('seturlapi');
                          this.iframe.src = url;

                          this.dialogom =true;
                        */
                    } else {
                        this.$toasted.show('Mode livraison obligatoire !', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Mode de payement obligatoire !', this.ToastTabError)
                }

            },


            // on envoie les infos du payement au partner dedié si retour == OK on crée un contrat à la suite
            payement_end: function (params) {
                const Contrat = {
                    numero_police: params.numeroDevis,
                    userid: params.userid,
                    brancheid: params.brancheid._id,
                    partenaireid: params.partenaireid._id,
                    devisid: params._id,
                    dateEffet: params.dateEffet,
                    dateEcheance: params.dateEcheance,
                    dateSouscription: params.dateSouscription,
                    taxe: params.taxe,
                    prime_nette: params.prime_nette,
                    prime_ttc: params.prime_ttc,
                    bonus: params.bonus,
                    accessoires: params.accessoires,
                };

                if (this.$store.state.devispayementDiffere.devis.brancheid.branche == 'Automobile') {
                    Contrat.details = params.vehicules
                }

                if (this.$store.state.devispayementDiffere.devis.brancheid.branche == 'Voyage') {
                    Contrat.details = this.tableau_info_passager
                }

                if (this.$store.state.devispayementDiffere.devis.brancheid.branche == 'Habitation') {
                    const habitat = {
                        typeBien: this.$store.state.devispayementDiffere.devis.typeBien,
                        nombrepiece: this.$store.state.devispayementDiffere.devis.nombrepiece,
                        nombreetage: this.$store.state.devispayementDiffere.devis.nombreetage,
                        naturecouverture: this.$store.state.devispayementDiffere.devis.naturecouverture,
                        adresselogement: this.$store.state.devispayementDiffere.devis.adresselogement,
                        environnement_immediat: this.$store.state.devispayementDiffere.devis.environnement_immediat,
                        valeurcontenu: this.$store.state.devispayementDiffere.devis.valeurcontenu,
                        valeurbatiment: this.$store.state.devispayementDiffere.devis.valeurbatiment,
                        qualiteassure: this.$store.state.devispayementDiffere.devis.qualiteassure
                    };
                    Contrat.details = habitat
                }

                Api().post('contrat/add', Contrat)
                    .then(response => {
                        this.IsPaid = true;
                        this.dialog = false;
                        this.notif = response.data.message;
                        this.contratToStore = response.data.contrat;
                        this.contratToStore.assureur = response.data.assureur;
                        this.contratToStore.branche = response.data.Thebranche;
                        this.$store.dispatch('setNewcontrat', this.contratToStore)
                    })
            },

            telecharger_le_devis: function (params) {
                Api().get('devis/download/' + params._id)
                    .then(response => {
                        let url = response.data.lien;
                        window.open(url, '_blank');
                    })
            },
            //  Date object formater to String
            DateFormater: function (TheDate) {
                if (TheDate) {
                    let laDate = new Date(TheDate);
                    let TheDay = laDate.getDate();
                    let TheMonth = laDate.getMonth() + 1;
                    let TheYear = laDate.getFullYear();
                    if (TheMonth < 10 && TheDay < 10) {
                        return TheYear + '-0' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth > 10 && TheDay < 10) {
                        return TheYear + '-' + TheMonth + '-0' + TheDay
                    }
                    if (TheMonth < 10 && TheDay > 10) {
                        return TheYear + '-0' + TheMonth + '-' + TheDay
                    } else {
                        return TheYear + '-' + TheMonth + '-' + TheDay
                    }
                }
            },

            //Fonction permettant de fermer le popup liste passager et declencher popup Upay 
            PayementSpecialVoyage() {
                this.dialogInfoPassager = false;
                this.dialogInfoPassagerMobile = false;
                this.getPay()
            },
            ManipPaiement() {
                this.dialogInfoPassager = false,
                    this.dialogInfoPassagerMobile = false;
                this.showPaymentBLock = true

            },

            Detail_info_passager() {
                if (this.nom_passager && this.prenom_passager && this.nationalite_passager) {
                    if (this.numero_ci_passager && this.date_delivrance && this.date_expiration && this.dateNaissance && this.genre) {
                        let Un_passager = {
                            nom_passager: this.nom_passager,
                            prenom_passager: this.prenom_passager,
                            num_passager: this.num_passager,
                            nationalite_passager: this.nationalite_passager,
                            numero_ci_passager: this.numero_ci_passager,
                            dateNaissance: this.dateNaissance,
                            date_delivrance: this.date_delivrance,
                            date_expiration: this.date_expiration,
                            genre: this.genre
                        };

                        if (this.nbPassager > 0) {
                            this.tableau_info_passager.push(Un_passager);
                            this.nom_passager = '';
                            this.prenom_passager = '';
                            this.num_passager = '';
                            this.nationalite_passager = '';
                            this.numero_ci_passager = '';
                            this.date_delivrance = '';
                            this.date_expiration = '';
                            this.genre = ''
                        }
                        this.nbPassager = this.nbPassager - 1;
                        if (this.nbPassager === 0) {
                            this.$store.dispatch('setListeBeneficiaire', this.tableau_info_passager);
                            this.continue_btn = true
                        }

                    } else {
                        this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                }
            },

            /* API UPAY ATPS */
            getPay: function () {
                getUpay(this.mention_ttc, this.mode_payement)
            },
            getPayintouch: function () {
                inTouch(this.mention_ttc, this.mode_payement)

            }
        },


        // Avant la destruction du composant pour charger un autre
        beforeDestroy() {
            this.$store.dispatch('setDevisPayementDiffere', null)
        },


        watch: {
            notif: function () {
                if (this.notif == 'Contrat cree mais non envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notif == 'Contrat cree et envoye par email') {
                    this.$router.push('/payement/succes');
                    this.notif = null
                } else if (this.notif == 'YET') {
                    this.$toasted.show("Vous avez déjà souscrit à une assurance pour cette période !", this.ToastTabError);
                    this.notif = null;
                    this.$router.push('/contrat/cumule')
                } else {
                    this.$router.push('/payement/failed');
                    this.notif = null
                }
            },
            notifDeviParMail: function () {
                if (this.notifDeviParMail == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par mail', this.ToastTabSucess)
                } else {
                    this.$toasted.show("Le devis n'a pas pu être envoyé par mail", this.ToastTabError)
                }
            },
            mode_livraison: function () {
                this.mention_ttc = parseInt(this.svgTTC);
                if (this.mode_livraison == 'a_docimicile') {
                    this.adresse = true;
                    this.prix_livraison = null
                } else if (this.mode_livraison == 'reseau_partenaire') {
                    this.mention_ttc = parseInt(this.svgTTC) + 500
                } else if (this.mode_livraison == 'locaux_assuraf') {
                    this.mention_ttc = parseInt(this.svgTTC)
                }
            }
        },
        mounted: function () {
            window.scrollTo(0, 0);
            this.getListePays();
            if (this.$store.state.user && this.$store.state.devispayementDiffere) {
                this.mention_ttc = this.$store.state.devispayementDiffere.devis.prime_ttc;
                this.svgTTC = this.$store.state.devispayementDiffere.devis.prime_ttc;
                this.Devis_pour_souscription = this.$store.state.devispayementDiffere.devis;
                this.branche = this.$store.state.devispayementDiffere.devis.brancheid.branche;
                if (this.$store.state.devispayementDiffere.devis.brancheid.branche == 'Automobile') {
                    for (let index = 0; index < this.Devis_pour_souscription.vehicules.length; index++) {
                        this.listegaranties.push(this.Devis_pour_souscription.vehicules[index].garanties)
                    }
                } else {
                    this.listegaranties = this.Devis_pour_souscription.garanties
                }
                if (this.$store.state.devispayementDiffere.devis.brancheid.branche == 'Voyage') {
                    this.nbPassager = this.$store.state.devispayementDiffere.devis.nbpassager
                }

            } else {
                this.$router.push('/')
            }
            this.Mano = 5
        }

    }
</script>

<style scoped>
    .row-container {
        background: white;
    }

    .to-top {
        margin-top: -5%
    }

    .to-left {
        text-align: left;
    }

    .to-right {
        float: right;
        padding-right: 5%
    }

    .to-right-mobile {
        float: right;
        margin-right: 2%
    }

    .to-left span {
        color: black;
        font-weight: bold;
    }

    .table-donnees {
        border-collapse: collapse;
    }

    .table-donnees tr td {
        border: 1px solid lightgrey !important;
    }

    .List-cout li {
        list-style: none;

    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .answer {
        position: relative;
        margin-right: 0;
        float: left;
        display: block;
        margin-right: 2.12766%;
        width: 100%;
    }

    .highlight {
        padding: 6px 12px;
        display: -ms-flexbox;
        display: flex;
        position: relative;
        font-size: .0625rem;
        cursor: pointer;
        color: #6d6d6d;
        border: solid 1px transparent;
        border-bottom: solid 1px #e9e9e9;
        border-radius: 3px;
        transition: background .4s;
    }

    .highlight:hover {
        background-color: rgba(255, 164, 9, 0.3);
        padding-left: 10px;
        transition-duration: 0.5s;
    }

    ul li {
        list-style: none;
        padding-top: 7px
    }

    #valeur {

        margin-left: 40%;
    }

    .container {
        padding: 0px !important;
    }

    .uppercase {
        font-weight: bold;
        color: #ffa409;
        text-transform: uppercase;
        font-size: 16px
    }

    .container {
        padding: 0px !important;
    }

    .head {
        background-color: rgb(91, 148, 188);
        color: white;
        font-size: 18px;
    }

    body {
        font-family: Georgia !important;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .selectatMobile {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 95%;
        border-bottom: 1px solid gray;
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 90%;
        border-bottom: 1px solid gray;
    }

    .border-radius {
        border-radius: 20px !important
    }


    .form .plan input, .form .payment-plan input, .form .payment-type input {
        display: none;
    }

    .form label {
        margin: 15px;
        width: 130px;
        position: relative;
        color: #333;
        font-family: Georgia !important;
        border-radius: 20px !important;
        background-color: #fff;
        font-size: 15px;
        text-align: center;
        height: 130px;
        display: block;
        cursor: pointer;
        border: 3px solid transparent;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .form .plan input:checked + label, .form .payment-plan input:checked + label, .form .payment-type input:checked + label {
        border-radius: 20px !important;
        background-color: #ffa409;
        color: #fff;

    }

    .form .plan input:checked + label:after, form .payment-plan input:checked + label:after, .form .payment-type input:checked + label:after {
        content: "\2713";
        width: 40px;
        height: 40px;
        line-height: 40px;
        border-radius: 100%;
        border: 2px solid #ffa409;
        background-color: #fff;
        color: #ffa409;
        z-index: 999;
        position: absolute;
        top: -10px;
        right: -10px;
    }


    /*================== CSS SELECT GLOBAL AUTO===================*/
    /* Reset Select */
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        appearance: none;
        outline: 0;
        box-shadow: none;

        background: #fff;
    }

    /* Remove IE arrow */
    select::-ms-expand {
        display: none;
    }

    select {
        flex: 1;
        padding: 0 .5em;
        color: grey;
        cursor: pointer;
    }

    /*================== CSS SELECT DESKTOP AUTO===================*/
    /* Custom Select */
    .select {
        position: relative;
        display: flex;
        width: 100%;
        height: 3em;
        line-height: 3;
        background: #fff;
        overflow: hidden;
        border: 2px solid #D3D3D3 !important;
        border-radius: 35px;
    }

    /* Arrow */
    .select::after {
        content: '\2228';
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 1em;
        background: #fff;
        cursor: pointer;
        pointer-events: none;
        -webkit-transition: .25s all ease;
        -o-transition: .25s all ease;
        transition: .25s all ease;
    }

    /* Transition */
    .select:hover::after {
        color: #f39c12;
    }
</style>
